<div [class]="classes?.imgWrapper" (click)="selectEntity()">
    <img [class]="classes?.img" src="./assets/img/websites/code-placeholder.svg" alt="code placeholder" />
    <div [class]="classes?.text">
        {{ "custom_code_on_site" | translate }}
    </div>
</div>
